import { render } from "./ResultLinks.vue?vue&type=template&id=7d0855d9"
const script = {}
script.render = render

export default script